import React from 'react';
const pills = ['🚀 FORMACIÓN EN VIVO GRATIS', '💎 COMUNIDAD ACTIVA', '⚡ IMPLEMENTACIÓN PASO A PASO', '📈 PENSADO PARA PRINCIPIANTES', '📱 ACCESO POR WHATSAPP'];
// Duplicate for seamless marquee
const marqueeItems = [...pills, ...pills, ...pills, ...pills];
export function TopBanner() {
  return <div className="bg-darkGreen py-3 overflow-hidden whitespace-nowrap flex items-center border-b border-white/10" data-id="element-101">
      <div className="animate-marquee flex gap-4 w-max" data-id="element-102">
        {marqueeItems.map((text, index) => <div key={index} className="flex items-center justify-center px-4 py-1.5 rounded-full border border-white/20 bg-white/5 text-white text-xs md:text-sm font-medium tracking-wide" data-id="element-103">
            {text}
          </div>)}
      </div>
    </div>;
}